module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/change-password/change-password.component.scss
// module id = ./src/app/pages/home/change-password/change-password.component.scss
// module chunks = main